import React from 'react';
import {
    Page,
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';
import css from './LandinPagePricing.css';
import { getLpSchemaObj, facebookImages, twitterImages } from '../LandingPage/common/helpers';
import { useSelector } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
    BenefitsWithCredits,
    SectionHero,
    SectionRewards,
    CreditsAsPackage,
    FAQ,
    CreditsSection,
    EngagementSection,
} from '../LandingPage/sectionsPricing';

const schemaTitle = 'Preisgestaltung & Credits | HorseDeal';
const schemaDescription =
    'Hier erfährst Du alles über unsere Preisgestaltung und welche Vorteile dir Credits bieten. Mehr erfahren.';

export default () => {
    const scrollingDisabled = useSelector(state => isScrollingDisabled(state));

    return (
        <Page
            scrollingDisabled={scrollingDisabled}
            contentType="website"
            description={schemaDescription}
            title={schemaTitle}
            facebookImages={facebookImages}
            twitterImages={twitterImages}
            schema={getLpSchemaObj(schemaTitle, schemaDescription)}
        >
            <LayoutSingleColumn>
                <LayoutWrapperTopbar>
                    <TopbarContainer />
                </LayoutWrapperTopbar>
                <LayoutWrapperMain
                    className={css.layout}
                    blobBackground
                    blobProps={{
                        xDistance: 20,
                        baseWidth: 760,
                    }}
                >
                    <main className={css.container}>
                        <SectionHero />
                        <SectionRewards />
                        <BenefitsWithCredits />
                        <CreditsAsPackage />
                        <FAQ endIndex={6} />
                        <CreditsSection />
                        <FAQ startIndex={6} />
                        <EngagementSection />
                    </main>
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSingleColumn>
        </Page>
    );
};
